module.exports = __webpack_public_path__ + "img/show_it.8407706f.svg";